import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { styled } from 'styled-components';
import { Box } from '@design-system/box';
import { CATEGORIES, FontAwesomeIcon } from '@design-system/font-awesome-icon';
import { useBreakpoint } from '@design-system/theme';
export const StaticGoogleMapMessage = ({ message, }) => {
    const breakpoint = useBreakpoint();
    const height = breakpoint === 's' ? 124 : 172;
    return (_jsx(Box, { alignItems: "center", flexDirection: "column", height: height, justifyContent: "center", p: 0, width: "100%", children: _jsxs(Box, { alignItems: "center", flexDirection: "column", children: [_jsx(FontAwesomeIcon, { color: "primary", height: "48px", iconName: "map-location-dot", iconType: CATEGORIES.DUOTONE }), _jsx(TextWrapper, { font: "metadata-regular-dove", mt: 24, children: message })] }) }));
};
const TextWrapper = styled(Box) `
  max-width: 165px;
  text-align: center;
`;
//# sourceMappingURL=StaticGoogleMapMessage.js.map